import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'potracking' })
export class PotrackingListPipe implements PipeTransform {
    transform(value:any[],searchText:string ){

       if(!searchText){
  //       console.log('no search')
         return value  
       }

       return value.filter(it=>{   
           const ponumber = it.ponumber.toString().toLowerCase().includes(searchText.toLowerCase())
		   const costcenter = it.costcentername !==null? it.costcentername.toLowerCase().includes(searchText.toLowerCase()) : value
        //    if(it.invoicenumber == null){
        //     it.invoicenumber = ""
        //     }
        //     const invoicenumber = it.invoicenumber.toString().toLowerCase().includes(searchText.toLowerCase())
        //     const requestorname = it.requestorname.toString().toLowerCase().includes(searchText.toLowerCase())
		//     const vendorname = it.vendorname.toString().toLowerCase().includes(searchText.toLowerCase())
          
        //    return (ponumber + invoicenumber + requestorname + vendorname);      
        return (ponumber + costcenter);      
       }) 
    }
}